export enum CrudAction {
  NONE = "none",
  ADD = "insert",
  UPDATE = "update",
  DELETE = "delete",
}